<template>
  <div class="ochart" v-loading="isLoading" @click="resetPosition">
    <OrgChart
      :data="chartData"
      :vue="Vue"
      :html-to-canvas="html2canvas"
      node-id="_id"
      container-class="orgchart-container"
      chart-class="departmentOchart-chart"
      common-class="fa"
      spinner-class="fa fa-circle-o-notch fa-spin spinner"
      export-btn-class
      left-arrow-class="fa-chevron-left"
      right-arrow-class="fa-chevron-right"
      up-arrow-class="fa-chevron-up"
      down-arrow-class="fa-chevron-down"
      toggle-btn-on-class="fa-plus-square"
      toggle-btn-off-class="fa-minus-square"
      parent-node-symbol-class
      :zoom="false"
      @drag="updateDataOnDrag"
    >
      <div slot-scope="{ nodeData }">
        <div id="orgdepartment"
             :class="[departmentName===nodeData.部门?'highlight':'','title company-orgdepartment-across']"
             style="overflow:unset"
             @dblclick="showDepartmentList(nodeData)"
        >
          <p class="span-maxcontent">{{ nodeData.部门 }}</p>
          <p class="span-maxcontent">人数：{{ nodeData.count }}</p>
          <p class="span-maxcontent">与人选绑定人数：{{ nodeData.bindRadishes }}</p>
        </div>
      </div>
    </OrgChart>
  </div>
</template>
<script>
import OrgChart from '@c42/vue-orgchart'
import Vue from 'vue'
import html2canvas from 'html2canvas'

export default {
  components: { OrgChart },
  props: {
    departments: { type: Array, default: () => [] },
    companyName: { type: String, default: '' },
    departmentName: { type: String, default: '' },
    companyNode: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      Vue,
      html2canvas,
      chartData: {
        _id: 1,
        名称: '无',
        children: [],
      },
      isLoading: false,
      zIndex: '',
    }
  },
  watch: {
    departmentName(newValue, oldValue) {
      if (newValue) {
        const nodeData = this.departments.find(v => v.部门 === newValue)
        if (nodeData) this.resetPosition(nodeData)
      }
    },
    departments(newValue, oldValue) {
      if (newValue) this.toTreeData(newValue)
    },
  },
  methods: {
    initChartData() {
      this.chartData = {
        _id: 1,
        部门: '无',
        children: [],
      }
    },
    resetPosition(nodeData) {
      const box = this.$el.querySelector('.departmentOchart-chart')
      if (!box) return
      const boxRect = box.getBoundingClientRect()
      const dom = box.querySelector(`#${nodeData._id}`)
      if (!dom) return
      const domRect = dom.getBoundingClientRect()
      const left = domRect.left - boxRect.left
      box.style.transform = `matrix(1, 0, 0, 1, -${left}, 0)`
    },
    showDepartmentList(nodeData) {
      this.$emit('showDepartmentList', nodeData)
    },
    toTreeData() {
      let tree = []
      let pos = {}
      let i = 0
      let num = 0

      const { companyName } = this

      const parentnNode = JSON.parse(JSON.stringify(this.companyNode))
      parentnNode.children = this.departments

      this.initOchartPosition()
      this.chartData = parentnNode
      this.copyChartData = JSON.parse(JSON.stringify(this.chartData))
    },
    initOchartPosition() {
      const dom = this.$el.querySelector('.departmentOchart-chart')
      if (dom) dom.style.transform = 'matrix(1, 0, 0, 1, 0, 0)'
    },
    async updateDataOnDrag(params) {
      this.chartData = JSON.parse(JSON.stringify(this.copyChartData))
    },
  },
}
</script>
<style>
.departmentOchart-chart {
  background-color: #f3f2f2;
  padding-bottom: 20px;
  padding-right: 20px;
}
</style>
<style src='../../statistics/css/departmentOchart.css' scoped></style>
